import { createSlice } from '@reduxjs/toolkit';

import {
  BadgeState,
  CreateBadgePayload,
  DeleteBadgePayload,
  SetBadgesPayload,
  UpdateBadgePayload
} from './badge.types';

export const initialState: BadgeState = {
  badges: []
};

export const BadgeSlice = createSlice({
  name: 'badge',
  initialState,
  reducers: {
    setBadges: (state, action: SetBadgesPayload) => {
      state.badges = action.payload;
    },
    createBadge: (state, action: CreateBadgePayload) => {
      state.badges.push(action.payload);
    },
    updateBadge: (state, action: UpdateBadgePayload) => {
      const badge = action.payload;

      const index = state.badges.findIndex(({ externalReference }) => externalReference === badge.externalReference);

      if (index !== -1) {
        state.badges.splice(index, 1, badge);
      }
    },
    deleteBadge: (state, action: DeleteBadgePayload) => {
      const index = state.badges.findIndex(({ externalReference }) => externalReference === action.payload);

      if (index !== -1) {
        state.badges.splice(index, 1);
      }
    }
  }
});

export const { setBadges, createBadge, updateBadge, deleteBadge } = BadgeSlice.actions;

export default BadgeSlice.reducer;
